import React, {Component} from 'react';
import Title from '../base/title';
import api from '../../utils/api';

let toFloat = (number) => {
  return number ? parseFloat(number) : parseFloat(0);
};

export default class Prices extends Component {

  constructor(props) {
    super(props);
    this.state = {
      opened: true,
      loader: ' loader-box',
      strategy: {}
    }
    this.goToSimulador = this.goToSimulador.bind(this);
  }

  componentDidMount() {
    let _self = this;
    let strategy = {};
    api.get('filters/products').then(resp => {
      resp.data.forEach(prod => {
        strategy[prod.short_name] = {}
      });
      api.get('widgets/actual-prices/?type=' + this.props.level + '&id=' + this.props.id).then(resp => {
        resp.data.forEach((price, index) => {
          let key = Object.keys(strategy)[index];
          if (!strategy[key]) strategy[key] = {}

          strategy[key].pra = toFloat(price.reference_price).toFixed(2);
          strategy[key].pm = toFloat(price.pm_pvp).toFixed(2);
          strategy[key].da = toFloat(price.difference_reference_price_vs_pm_pvp).toFixed(2);
          strategy[key].pvp = toFloat(price.pvp).toFixed(2);
          strategy[key].pvppr = { value: toFloat(price.difference_pvp_vs_reference_price).toFixed(2), position: 'up' };
        })
        _self.setState({strategy: strategy, loader: ''});
      });
    });
  }

  goToSimulador() {
    window.location = '/simulador';
  }

  render() {
    let _self = this;
    return <div className="row">
        <Title isOpen={_self.state.opened} toggle={() => { _self.setState({ strategy: {}, opened: !_self.state.opened }, function() { if (_self.state.opened) _self.componentDidMount(); }); }} edit={ {onClick: this.goToSimulador, icon: 'fas fa-arrow-right', label: 'SIMULAR PRECIOS'} } text="PRECIOS ACTUALES" isGray={true} hasIcon={true} />
        {this.state.opened && <div className="row">
          <div className="col s12">
            <div className="row">
              <div className={"marketShare" + this.state.loader}>
                <table className='c-table'>
                  <thead>
                    <tr>
                      <td>&nbsp;</td>
                      {Object.keys(_self.state.strategy).map((key) =>
                        <td key={key}>{key}</td>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Precio Referencia Actual ($)</td>
                      {Object.keys(_self.state.strategy).map((key) =>
                        <td key={key}><b>{_self.state.strategy[key].pra}</b></td>
                      )}
                    </tr>
                    <tr>
                      <td>Precio PM Actual ($)</td>
                      {Object.keys(_self.state.strategy).map((key) =>
                        <td key={key}>{_self.state.strategy[key].pm}</td>
                      )}
                    </tr>
                    <tr>
                      <td>Diferencia Actual (%)</td>
                      {Object.keys(_self.state.strategy).map((key) =>
                        <td className="color-red" key={key}><b>{_self.state.strategy[key].da}</b></td>
                      )}
                    </tr>
                    <tr>
                      <td>PVP Actual ($)</td>
                      {Object.keys(_self.state.strategy).map((key) =>
                        <td key={key}>{_self.state.strategy[key].pvp}</td>
                      )}
                    </tr>
                    <tr>
                      <td>PVP vs. Precio Referencia (%)</td>
                      {Object.keys(_self.state.strategy).map((key) =>
                        <td key={key}><i className={'fas fa-caret-' + _self.state.strategy[key].pvppr.position}></i>&nbsp;&nbsp;{_self.state.strategy[key].pvppr.value}</td>
                      )}
                    </tr>
                  </tbody>
                  </table>
              </div>
            </div>
          </div>
        </div>}
      </div>
  }

}


// WEBPACK FOOTER //
// ./src/containers/analisis/prices.js